module.exports = __webpack_public_path__ + "img/icon-analytics-black.3b9902c2.svg";